import { useState } from "react";
import { PageHeader, Panel, Loading, ErrorBox, Kpi } from "@/components/Widgets";
import { useApi, df, nf } from "@/lib/api";

const INTENT_STYLE = {
  "Domanda prezzo": "border-[#C05C3D] text-[#C05C3D]", "Interesse / lead": "border-[#2A4B3C] text-[#2A4B3C]",
  "Domanda tecnica": "border-[#5E7C8A] text-[#5E7C8A]", "Obiezione / dubbio": "border-[#8C5A3C] text-[#8C5A3C]",
  "Apprezzamento": "border-[#7A8B4F] text-[#7A8B4F]", Altro: "border-[#B9A88F] text-[#5C5C58]",
};

export default function Comments() {
  const { data, error, loading } = useApi("/comments");
  const [intent, setIntent] = useState("Tutti");
  if (loading) return <Loading />;
  if (error) return <ErrorBox msg={error} />;
  const list = data.comments.filter((c) => intent === "Tutti" || c.intent === intent);
  const maxK = Math.max(...data.keywords.map((k) => k.count), 1);
  return (
    <>
      <PageHeader eyebrow={`${data.total} commenti analizzati`} title="Cosa dice il tuo pubblico" desc="Ogni commento è classificato per intenzione: domande sul prezzo e richieste di info sono lead caldi da contattare in DM." />
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-4">
        {data.intents.slice(0, 5).map((i) => <Kpi key={i.name} testid={`intent-kpi-${i.name}`} label={i.name} value={nf(i.value)} accent={i.name === "Interesse / lead" || i.name === "Domanda prezzo"} />)}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 mb-4">
        <Panel testid="keyword-cloud" title="Parole più usate" sub="Nei commenti" className="lg:col-span-2">
          <div className="flex flex-wrap gap-x-4 gap-y-2 items-baseline">
            {data.keywords.map((k) => <span key={k.word} className="font-display text-[#2A4B3C] hover:text-[#C05C3D] transition-colors cursor-default" style={{ fontSize: `${12 + (k.count / maxK) * 22}px`, opacity: 0.45 + (k.count / maxK) * 0.55 }}>{k.word}</span>)}
          </div>
        </Panel>
        <Panel testid="top-commenters" title="Fan più attivi" sub="Da coinvolgere e fidelizzare">
          <ul className="space-y-2">{data.top_commenters.map((u, i) => <li key={u.username} className="flex justify-between text-sm"><span><span className="font-mono-num text-xs text-[#5C5C58] mr-2">{i + 1}</span>@{u.username}</span><span className="font-mono-num text-xs">{u.count}</span></li>)}</ul>
        </Panel>
      </div>
      <Panel testid="comments-list" title="Commenti" action={
        <select data-testid="intent-filter" value={intent} onChange={(e) => setIntent(e.target.value)} className="border border-[#E8E8E4] text-xs px-2 py-1.5 bg-white">
          {["Tutti", ...data.intents.map((i) => i.name)].map((n) => <option key={n}>{n}</option>)}
        </select>}>
        <div className="divide-y divide-[#E8E8E4] max-h-[600px] overflow-y-auto">
          {list.map((c) => (
            <div key={c.id} className="py-3 flex gap-4 items-start" data-testid={`comment-${c.id}`}>
              <span className={`text-[10px] font-semibold px-1.5 py-0.5 border whitespace-nowrap ${INTENT_STYLE[c.intent]}`}>{c.intent}</span>
              <div className="flex-1"><div className="text-sm">{c.text}</div><div className="text-xs text-[#5C5C58] mt-1">@{c.username} · {c.platform} · {df(c.timestamp)}</div></div>
            </div>
          ))}
          {!list.length && <p className="text-sm text-[#5C5C58] py-4">Nessun commento.</p>}
        </div>
      </Panel>
    </>
  );
}
